//@ts-nocheck
import Swiper from "swiper11";
import type { SwiperOptions } from "swiper11/types";
import { CountUp } from "countup.js";
function initCanvasAnimation() {
  // 可调参数
  var BACKGROUND_COLOR = "rgba(0,43,54,0)"; // 背景颜色
  var POINT_NUM = 200; // 星星数目
  var POINT_COLOR = "rgba(255,255,255,0.7)"; // 点的颜色
  var LINE_LENGTH = 10000; // 点之间连线长度(的平方)
  if(screen.width < 621){
    POINT_NUM = 100;
  }

  // 创建背景画布
  var cvs = document.createElement("canvas");
  cvs.width = window.innerWidth;
  cvs.height = window.innerHeight;
  cvs.style.cssText =
    "\
    position:fixed;\
    top:0px;\
    left:0px;\
    z-index:-1;\
    opacity:1.0;\
    height: 100%;\
    ";
  document.querySelector(".index_banner1").appendChild(cvs);

  var ctx = cvs.getContext("2d");

  var startTime = new Date().getTime();

  //随机数函数
  function randomInt(min, max) {
    return Math.floor((max - min + 1) * Math.random() + min);
  }

  function randomFloat(min, max) {
    return (max - min) * Math.random() + min;
  }

  //构造点类
  function Point() {
    this.x = randomFloat(0, cvs.width);
    this.y = randomFloat(0, cvs.height);

    var speed = randomFloat(0.3, 1.4);
    var angle = randomFloat(0, 2 * Math.PI);

    this.dx = Math.sin(angle) * speed;
    this.dy = Math.cos(angle) * speed;

    this.r = 1.2;

    this.color = POINT_COLOR;
  }

  Point.prototype.move = function () {
    this.x += this.dx;
    if (this.x < 0) {
      this.x = 0;
      this.dx = -this.dx;
    } else if (this.x > cvs.width) {
      this.x = cvs.width;
      this.dx = -this.dx;
    }
    this.y += this.dy;
    if (this.y < 0) {
      this.y = 0;
      this.dy = -this.dy;
    } else if (this.y > cvs.height) {
      this.y = cvs.height;
      this.dy = -this.dy;
    }
  };

  Point.prototype.draw = function () {
    ctx.fillStyle = this.color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    ctx.closePath();
    ctx.fill();
  };

  var points = [];

  function initPoints(num) {
    for (var i = 0; i < num; ++i) {
      points.push(new Point());
    }
  }

  // var p0 = new Point(); //鼠标
  // p0.dx = p0.dy = 0;
  // var degree = 2.5;
  // // document.onmousemove = function (ev) {
  // //     p0.x = ev.clientX;
  // //     p0.y = ev.clientY;
  // // }
  // document.onmousedown = function (ev) {
  //   degree = 5.0;
  //   p0.x = ev.clientX;
  //   p0.y = ev.clientY;
  // };
  // document.onmouseup = function (ev) {
  //   degree = 2.5;
  //   p0.x = ev.clientX;
  //   p0.y = ev.clientY;
  // };
  // window.onmouseout = function () {
  //   p0.x = null;
  //   p0.y = null;
  // };

  function drawLine(p1, p2, deg) {
    var dx = p1.x - p2.x;
    var dy = p1.y - p2.y;
    var dis2 = dx * dx + dy * dy;
    if (dis2 < 2 * LINE_LENGTH) {
      // if (dis2 > LINE_LENGTH) {
      //   if (p1 === p0) {
      //     p2.x += dx * 0.03;
      //     p2.y += dy * 0.03;
      //   } else return;
      // }
      var t = (1.05 - dis2 / LINE_LENGTH) * 0.2 * deg;
      ctx.strokeStyle = "rgba(255,255,255," + t + ")";
      ctx.beginPath();
      ctx.lineWidth = 1.5;
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.closePath();
      ctx.stroke();
    }
    return;
  }

  //绘制每一帧
  function drawFrame() {
    cvs.width = window.innerWidth;
    cvs.height = window.innerHeight;
    ctx.fillStyle = BACKGROUND_COLOR;
    ctx.fillRect(0, 0, cvs.width, cvs.height);

    var arr = points
    for (var i = 0; i < arr.length; ++i) {
      for (var j = i + 1; j < arr.length; ++j) {
        drawLine(arr[i], arr[j], 1.0);
      }
      arr[i].draw();
      arr[i].move();
    }

    window.requestAnimationFrame(drawFrame);
  }

  initPoints(POINT_NUM);
  drawFrame();
}

interface CreatedThumbsOpts {
  swiperOptions: SwiperOptions;
  cloneTarget?: string;
}

export function countUp(target: string = ".counter", opts: any = {}) {
  const List = $(target);
  if (!List.length) return;
  const defaults = {
    duration: 0.8,
    useEasing: false,
    enableScrollSpy: true,
    scrollSpyDelay: 0,
    ...opts,
  };
  List.each((_i, item) => {
    const Num = Number($(item).text());
    if (!Num || typeof Num !== "number") return;
    if(item.textContent?.split(".").length > 1){
      new CountUp(item, Num, Object.assign({decimalPlaces: item.textContent?.split(".")[1].length},defaults));
    }else{
      new CountUp(item, Num, defaults);
    }
  });
}

export function createdThumbs(swiper: Swiper, thumbsSelect: string, opts?: CreatedThumbsOpts) {
  const slideList = $(swiper.el).find(".swiper-slide");
  const container = $(thumbsSelect); // 缩略图Swiper
  const wrapper = $("<div class='swiper-wrapper'></div>");
  if (!slideList.length || !container.length) return;
  const tempFragment = document.createDocumentFragment();
  slideList.each((_i, item) => {
    const target = $(item).find(opts?.cloneTarget || ".img-box");
    const clone = $(target).clone().removeClass("zoomSl")[0];
    const slide = $(`<div class='swiper-slide'></div>`);
    slide.append(clone);
    tempFragment.appendChild(slide[0]); // Append the slide to the fragment
  });

  wrapper.append(tempFragment);
  container.append(wrapper);
  const THUMBS = new Swiper(container[0], opts?.swiperOptions ?? {});
  swiper.thumbs.swiper = THUMBS;
  swiper.on("afterInit", (S) => {
    S.thumbs.init();
    S.thumbs.update(true);
    S.update();
  });
  swiper.on("slideChange", (S) => {
    const thumbs = S.thumbs.swiper;
    const currentIdx = thumbs.params.loop ? S.activeIndex : S.realIndex;
    thumbs.slideTo(currentIdx, 500, false);
  });
}

export function resetImgSize({ nodeList, setImg = true, setBox = false, cb }: ResetImgSizeFn) {
  const temp: any[] = [];
  nodeList.each((_i, img) => {
    if (!$(img).is("img")) return;
    function resizeImage(image: HTMLImageElement) {
      const originalH = image.naturalHeight / 10 + "rem";
      const originalW = image.naturalWidth / 10 + "rem";
      if (setBox) {
        $(image).parents(".img-box").eq(0).css({
          height: originalH,
          width: originalW,
        });
      }
      if (setImg) {
        $(image).css({
          height: originalH,
          width: originalW,
        });
      }
      temp.push({
        item: img,
        w: originalW,
        h: originalH,
      });
      if (cb && typeof cb === "function") cb();
    }
    if ((img as HTMLImageElement).complete) {
      // 如果图片已加载
      resizeImage(img as HTMLImageElement);
    } else {
      $(img).on("load", function () {
        resizeImage(this as HTMLImageElement);
      });
    }
  });
  return temp;
}

interface WaveOpts {
  width?: number;
  height?: number;
  target: JQuery<HTMLElement>;
}
export function createWaveClipPath<T>(path: string, { width, height, target }: WaveOpts): T {
  if (!target || !target.length) {
    throw new Error("createWaveClipPath target is not defined!!!");
  }
  const applyClipPath = () => {
    const finalWidth = width || target.outerWidth();
    const finalHeight = height || target.outerHeight();
    const resultPath = path.replace(/\{\$w\}/g, finalWidth.toString()).replace(/\{\$h\}/g, finalHeight.toString());
    target.css({
      "clip-path": `path('${resultPath}')`,
    });
    return resultPath;
  };
  let resizeTimeout: number | undefined;
  const onResize = () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = window.setTimeout(() => {
      applyClipPath();
    }, 100);
  };
  window.addEventListener("resize", onResize);
  const result = applyClipPath();
  return result as unknown as T;
}

export function handleSendInquiry({ formId, trigger, opts }: SendInquiryOpts) {
  const formEl = $(formId)[0] as HTMLFormElement;
  $(trigger).on("click", () => {
    const triggerElement = $(formEl).data("triggerElement");
    const formData = new FormData(formEl);
    const readyToSend = beforeSubmit(formData);
    if (readyToSend) {
      if (opts && opts.onBeforeSend && typeof opts.onBeforeSend === "function") {
        opts.onBeforeSend(formData);
      }
      sendAjax(formData, triggerElement);
    }
  });
  const beforeSubmit = (data: FormData) => {
    let FLAG = true;
    const disableFields: any = {};
    const formElements = formEl.elements;
    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i] as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      const key = element.name;
      const type = element.type;
      
      if (type === "file" && (data.get(key)! as File).name === "") {
        data.delete(key);
      }
      if (element.disabled && element.value) {
        data.set(key, element.value);
      }
      if(key === 'content' && element.value === ''){
        data.set(key, '客户未填写内容');
      }
      const is_required = element.required;
      if (is_required && element.value === "" && !$(formEl[key]).attr('data-reqiured')) {
        FLAG = false;
        let msg: string | undefined = undefined;
        if (opts && opts.inquiryMsg && opts.inquiryMsg[key]) {
          msg = opts.inquiryMsg[key];
        }
        rejectMessage(key, msg);
        break;
      }
    }
    /*! custom Setting Start */
    if (opts && opts.fn && typeof opts.fn === "function") {
      opts.fn({ data, disableFields, rejectMessage });
    }
    return FLAG;
  };
  const rejectMessage = (key: string, msg?: string) => {
    formEl[key].focus();
    alert(msg ?? `请填写所有必填字段!`);
  };
  const sendAjax = (data: FormData, originalTrigger: HTMLElement) => {
    $.ajax({
      processData: false,
      contentType: false,
      type: "POST",
      url: "/inquiry",
      data: data,
      success: function (jsonResult) {
        if (jsonResult.code == 200) {
          ($(formEl)[0] as HTMLFormElement).reset();
          if (opts && opts.onSuccess && typeof opts.onSuccess === "function") {
            opts.onSuccess(jsonResult, originalTrigger);
          } else {
            location.href = "/page/thanks.html";
          }
        } else {
          if (opts && opts.onReject && typeof opts.onReject === "function") {
            opts.onReject(data, originalTrigger);
            alert(jsonResult.msg);
          }
        }
        $(":input[name = '__token__']").val(jsonResult.data.token);
      },
      error: function (data) {
        // if (opts && opts.onReject && typeof opts.onReject === "function") {
        //   opts.onReject(data, originalTrigger);
        //   alert(jsonResult.msg);
        // }
      },
    });
  };
}

/**
 * 防抖函数
 * @param {Function} fn 需要防抖的函数
 * @param {number} delay 延迟时间(毫秒)
 * @param {boolean} immediate 是否立即执行
 * @return {Function} 返回防抖后的函数
 */
export function debounce(fn: Function, delay = 300, immediate = false) {
  let timer: any = null;
  
  return function(...args: any) {
    //@ts-ignore
    const context = this;
    
    if (timer) clearTimeout(timer);
    
    if (immediate && !timer) {
      fn.apply(context, args);
    }
    
    timer = setTimeout(() => {
      timer = null;
      if (!immediate) {
        fn.apply(context, args);
      }
    }, delay);
  };
}

export default initCanvasAnimation;
